import { schema } from 'normalizr';
import consumer from './consumer';

const schemaEntity = new schema.Entity('consumptionPoint', {
  consumer,
});

export default schemaEntity;
